/* eslint-disable no-undef */
// TODO: remove code above and fix issues in case changing this file

(function() {
	'use strict';

	angular
		.module('dat.shared-components.common')
		.directive('datTooltip', datTooltip)
		.controller('TooltipCtrl', TooltipCtrl);

	function datTooltip() {
		var directive = {
			restrict: 'EA',
			replace: true,
			transclude: true,
			scope: {
				for: '@datFor',
				title: '@datTitle',
				showCloseLink: '@datShowCloseLink',
				position: '@datPosition',
				openOn: '@datOpenOn',
				options: '=datOptions',
				tooltipClass: '@datTooltipClass',
				toggleDisplayOn: '=datToggleDisplayOn',
				removeOnClose: '@datRemoveOnClose',
				closeAllOnOpen: '@datCloseAllOnOpen'
			},
			templateUrl: '/app/shared-components/common/tooltip.html',
			controller: 'TooltipCtrl',
			controllerAs: 'ctrl'
		};

		return directive;
	}

	TooltipCtrl.$inject = ['$scope', '$element', '$timeout', 'eventNameService'];

	function TooltipCtrl($scope, $element, $timeout, eventNameService) {
		var self = this,
			tooltip = null;

		self.m = {
			title: $scope.title,
			showCloseLink: $scope.showCloseLink
		};
		self.closeTooltip = closeTooltip;

		activate();

		////////////////////

		function activate() {
			tooltip = new Drop({ // Documentation: http://github.hubspot.com/drop/
				target: $($scope.for)[0],
				position: $scope.position,
				content: $element[0],
				openOn : $scope.openOn,
				classes : $scope.tooltipClass || '',
				constrainToWindow: false,
				tetherOptions: $scope.options, // Documentation: http://tether.io/
				remove: $scope.removeOnClose && $scope.removeOnClose === 'true'
			});

			if (!angular.isUndefined($scope.toggleDisplayOn)) {
				$scope.$watch('toggleDisplayOn', toggleDisplayOnHandler);
			}
			$scope.$on('$destroy', destroyCleanup);
			$scope.$on(eventNameService.toolTip.reposition, repositionToolTip);
		}

		function closeTooltip() {
			tooltip.close();
		}

		function toggleDisplayOnHandler(newValue) {
			if (newValue === true) {
				tooltip.open();
				$timeout(repositionToolTip, 1);

				return;
			}
			closeTooltip();
		}

		function repositionToolTip() {
			if (tooltip) {
				tooltip.position();
			}
		}

		function destroyCleanup() {
			if (tooltip) {
				//tooltip.destroy(); TODO: figure out why this fails in Karma
			}
		}
	}

})();
